import { PERMISSIONS } from '@conversed/shared/src/central/constants/permissions';
import { WebScraperJobStatus } from '@conversed/shared/src/central/dto/web-scraper.dto';
import { z } from 'zod';
import { createRESTContract } from '../../index';
import { LLMBlockSelectionSchema } from '../data-sources/data-sources.schema';

const WebScrapeBodySchema = z.object({
  url: z.string().url(),
  exclusions: z.string().url().array().optional(),
  label: z.string().optional(),
  sharedWithCompanyIds: z.array(z.string()).optional(),
  autoTraining: z.boolean().optional(),
  autoInclude: z.boolean().optional(),
  folderId: z.string().optional(),
  expiryDate: z.string().optional(),
  selectedLLMBlocks: LLMBlockSelectionSchema.array().optional(),
});

const WebScrapeResponseSchema = z.object({
  jobId: z.string(),
  status: z.enum(
    Object.values(WebScraperJobStatus) as [
      WebScraperJobStatus,
      ...WebScraperJobStatus[],
    ],
  ),
  message: z.string(),
});

const WebScraperJobStatusParamsSchema = z.object({
  jobId: z.string(),
});

const WebScraperJobStatusResponseSchema = z.object({
  jobId: z.string(),
  status: z.enum(
    Object.values(WebScraperJobStatus) as [
      WebScraperJobStatus,
      ...WebScraperJobStatus[],
    ],
  ),
  progress: z.number(),
  total: z.number(),
  url: z.string(),
  exclusions: z.array(z.string()),
  error: z.string().nullable(),
  startedAt: z.string(),
  completedAt: z.string().nullable(),
  dataSourceId: z.string().nullable(),
});

export type TWebScraperBody = z.infer<typeof WebScrapeBodySchema>;
export type TWebScraperResponse = z.infer<typeof WebScrapeResponseSchema>;
export type TWebScraperJobStatusResponse = z.infer<
  typeof WebScraperJobStatusResponseSchema
>;

export const webScraperContract = createRESTContract({
  scrapeWebsite: {
    path: '/web-scraper/scrape',
    method: 'POST',
    permissions: [PERMISSIONS.DATA_SOURCE.DATA_SOURCE_SCRAPE_WEBSITE],
    body: WebScrapeBodySchema,
    response: WebScrapeResponseSchema,
  },
  getJobStatus: {
    path: '/web-scraper/jobs/:jobId',
    method: 'GET',
    permissions: [PERMISSIONS.DATA_SOURCE.DATA_SOURCE_SCRAPE_WEBSITE],
    params: WebScraperJobStatusParamsSchema,
    response: WebScraperJobStatusResponseSchema,
  },
});
